module.exports = __webpack_public_path__ + "static/media/aprovado-icon.b4aceecc.svg";